import { Pipe, PipeTransform, inject } from '@angular/core';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { StoreConfigurationRepositoryService } from 'src/app/core/services/store-configuration/store-configuration-repository.service';
import { CashpointsPipe } from './cashpoints.pipe';
import { PercentageSavePipe } from './percentage-save.pipe';

// Define a special placeholder for MRP block
const MRP_BLOCK_START = '<p class="actual-price non-editable">';
const MRP_BLOCK_END = '</p>';


const DISCOUNT_BLOCK_START = '<p class=\"percentage-discount non-editable\">'
const DISCOUNT_BLOCK_END = '</p>'

const CASH_POINT_BLOCK_START = '<p class="cash-point-info non-editable">';
const CASH_POINT_BLOCK_END = '</p>';

const CASHPOINT_SVG = `<svg class="cash-point-svg" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg" > <path d="M46.062 28.4995L49.1176 36.6711C49.6938 38.2121 51.1353 39.2594 52.7789 39.3312L61.4947 39.7121C62.0492 39.7363 62.2764 40.4356 61.8421 40.7811L55.0146 46.2122C53.7272 47.2364 53.1765 48.931 53.6161 50.5164L55.9473 58.9233C56.0956 59.4581 55.5007 59.8903 55.038 59.584L47.7628 54.7691C46.3909 53.8611 44.6091 53.8611 43.2372 54.7691L35.962 59.584C35.4993 59.8903 34.9044 59.4581 35.0527 58.9233L37.3839 50.5164C37.8235 48.931 37.2728 47.2364 35.9854 46.2122L29.1579 40.7811C28.7236 40.4356 28.9508 39.7363 29.5053 39.7121L38.2211 39.3312C39.8647 39.2594 41.3062 38.2121 41.8824 36.6711L44.938 28.4995C45.1324 27.9797 45.8676 27.9797 46.062 28.4995Z" class="svg-color-stroke" stroke-width="3.5" /> <circle cx="45.5" cy="45.5" r="41.5" class="svg-color-stroke" stroke-width="6.225" /> <path d="M61.27 17.6042C65.005 19.6792 73.0975 25.0742 75.5875 36.6942" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> <path d="M28.8821 73.6274C25.1266 71.5899 16.9806 66.276 14.3746 54.6815" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> <path d="M77.87 43.3342C78.0775 45.8242 78.285 47.0692 77.455 51.0117" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> <path d="M75.8947 58.0467C74.956 60.3623 74.5793 61.5669 72.0593 64.7105" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> <path d="M67.2012 69.8086C65.3513 71.4882 64.4895 72.4104 60.8557 74.1504" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> <path d="M13.2008 47.225C13.2762 44.7275 13.2108 43.4671 14.4814 39.6437" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> <path d="M17.0268 32.3348C18.0841 30.0709 18.5227 28.8874 21.2022 25.8786" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> <path d="M26.5151 19.7406C28.4412 18.1488 29.345 17.2678 33.0558 15.6988" class="svg-color-stroke" stroke-width="5.395" stroke-linecap="round" /> </svg>`

const percentageSavePipe = new PercentageSavePipe();
const cashpointsPipe = new CashpointsPipe();
@Pipe({ name: 'interpolation', standalone: true })
export class InterpolationPipe implements PipeTransform {
  private storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);

  IMAGE_URLS = IMAGE_URLS;
  isCashPointEnabled: boolean = this.storeConfigurationRepositoryService.isCashPointEnabled();

  transform(
    htmlString: string,
    response: any,
    showCashpoint = false,
    showPercentageDiscount = true
  ) {

    if (response?.hasOwnProperty('one_line_description') || response?.hasOwnProperty('short_description')) {
      const tempElement = document.createElement('div');
      // Insert the one_line_description HTML into the temporary element
      tempElement.innerHTML = response?.one_line_description || response?.short_description;
      // Convert the HTML content into a string and modify the response
      response.one_line_description = (tempElement.innerText || tempElement.textContent) ?? '';
    }

    // Check if mrp and selling_price are the same and here selling_price is applicable amount
    if (response?.mrp === response?.selling_price) {
      // Remove the entire MRP block
      const mrpBlockRegex = new RegExp(`${MRP_BLOCK_START}.*?${MRP_BLOCK_END}`, 'g');
      htmlString = htmlString.replace(mrpBlockRegex, '');
    }

    // manage discount percentage to display with real data
    const discountBlockRegex = new RegExp(`${DISCOUNT_BLOCK_START}.*?${DISCOUNT_BLOCK_END}`, 'g');

    if (showPercentageDiscount) {
      htmlString = htmlString.replace(discountBlockRegex,
        percentageSavePipe.transform(response)
          ? `${DISCOUNT_BLOCK_START} ${percentageSavePipe.transform(response)} ${DISCOUNT_BLOCK_END}`
          : ''
      );
    } else {
      // Remove the entire discount block if showPercentageDiscount is false
      htmlString = htmlString.replace(discountBlockRegex, '');
    }

    // Managing cash-point Block
    const cashPointBlockRegex = new RegExp(`${CASH_POINT_BLOCK_START}.*?${CASH_POINT_BLOCK_END}`, 'g');

    if (!showCashpoint) {
      htmlString = htmlString.replace(cashPointBlockRegex, '');
    } else {
      htmlString = htmlString.replace(cashPointBlockRegex, this.isCashPointEnabled && cashpointsPipe.transform(response?.price_list) ? `${CASH_POINT_BLOCK_START} Earn ${cashpointsPipe.transform(response?.price_list)} ${CASHPOINT_SVG} Cashpoints ${CASH_POINT_BLOCK_END}` : '');
    }



    htmlString = htmlString.replace(/{{\s*(.*?)\s*}}/g, (_match, p1) => {
      let apiValue;

      // Always get value via path
      apiValue = this.getValueByPath(response, p1.trim());

      // Use fallback if value is undefined, null, or empty string
      if (apiValue === undefined || apiValue === null || apiValue === '') {
        // Special handling for image URLs or others if needed
        if (p1.includes('featured_images') && p1.includes('url')) {
          return this.IMAGE_URLS.noImagePlaceholder;
        }
        return ''; // Default fallback
      }

      // Round price values to remove decimals
      const priceFields = ['selling_price', 'mrp', 'actual_price', 'price', 'amount', 'total', 'subtotal'];
      const fieldName = p1.trim().toLowerCase();
      if (priceFields.some(field => fieldName.includes(field)) && typeof apiValue === 'number') {
        apiValue = Math.round(apiValue);
      }

      return apiValue;
    });


    // Remove any HTML tags with 'undefined' or 'null' content
    const removeUndefinedNullTags = (html: string) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const elements = doc.body.querySelectorAll('*');

      elements.forEach(element => {
        if (element.textContent === 'undefined' || element.textContent === 'null') {
          element.remove();
        }
      });

      return doc.body.innerHTML;
    };

    htmlString = removeUndefinedNullTags(htmlString);

    return htmlString;
  }

  // Getting the path of nested object
  getValueByPath(obj: any, path: string): any {
    return path.split('.').reduce((acc, key) => {
      if (acc && key) {
        const match = key.match(/^(\w+)(\[(\d+)\])?(\?)?$/);
        if (match) {
          const [, propName, , arrayIndex, optional] = match;
          if (propName && optional && acc[propName] === undefined) {
            return undefined; // Return undefined if optional and property is undefined
          }
          if (propName) {
            acc = arrayIndex ? acc[propName]?.[parseInt(arrayIndex, 10)] : acc[propName];
          }
        }
      }
      return acc;
    }, obj);
  }

}
